import Vue from 'vue';

export default {
  name: 'cmrControlPanelTrimOptions',
  components: {},
  props: ['dataObj'],
  data: function () {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  methods: {
    isRaised(item) {
      if (item == true)
        return "background-light-gray";
      else
        return 'background-white';
    },
    filterActions(item) {
      if (item == "read") {
        this.trim.read = !this.trim.read;
      }
      else if (item == "unread") {
        this.trim.unread = !this.trim.unread;
      }
      else if (item == "spotBill" && this.bSpotBillEnabled == true) {
        this.trim.spotBill = !this.trim.spotBill;
      }
      else if (item == "withAccess") {
        this.trim.withAccess = !this.trim.withAccess;
      }
      else if (item == "withNote") {
        this.trim.withNote = !this.trim.withNote;
      }
      else if (item == "discrepancy") {
        this.trim.discrepancy = !this.trim.discrepancy;
      }
      else if (item == "disconnected") {
        this.trim.disconnected = !this.trim.disconnected;
      }

      this.trimReadings();
    },

    trimReadings() {
      console.log("trim", this.trim)
    }



  },
}
